module.exports = __webpack_public_path__ + "img/home-visual-02_m.df6fd238.png";